@if (visible()) {
<ion-fab class="admin-fab" vertical="bottom" horizontal="end">
  <ion-fab-button
    class="admin-fab-main"
    [class.in-admin]="inAdmin()"
    [closeIcon]="icons.close"
    [attr.aria-label]="'menu.admin' | translate"
    [attr.title]="'menu.admin' | translate"
  >
    <ion-icon [icon]="icons.admin" aria-hidden="true"></ion-icon>
  </ion-fab-button>
  <ion-fab-list side="top">
    @for (p of pages; track p.url) {
    <ion-fab-button
      class="admin-fab-item"
      [class.is-current]="isCurrent(p.url)"
      [style.--tone]="p.tone"
      [attr.aria-label]="'menu.' + p.key | translate"
      [attr.aria-current]="isCurrent(p.url) ? 'page' : null"
      [attr.title]="'menu.' + p.key | translate"
      (click)="go(p.url)"
    >
      <ion-icon [icon]="p.icon" aria-hidden="true"></ion-icon>
    </ion-fab-button>
    }
  </ion-fab-list>
</ion-fab>
}
